import { ConfirmarSituacaoDialog, JustificativaField } from "@/shared/components";
import styles from "./situacao-cotacao-dialog.module.scss";
import type { SituacaoCotacaoDialogViewModel } from "./types-situacao-cotacao-dialog";

export function SituacaoCotacaoDialogView({
  acao,
  titulo,
  subtitulo,
  oQueAcontece,
  confirmLabel,
  tituloEfeitos,
  identificacao,
  justificativa,
  onConfirmar,
  onCancelar,
}: SituacaoCotacaoDialogViewModel) {
  return (
    <ConfirmarSituacaoDialog
      acao={acao}
      titulo={titulo}
      subtitulo={subtitulo}
      oQueAcontece={oQueAcontece}
      confirmLabel={confirmLabel}
      tituloEfeitos={tituloEfeitos}
      corpo={
        <div className={styles.identificacao} data-testid="situacao-cotacao-identificacao">
          <p className={styles.intro}>{identificacao.intro}</p>
          <div className={styles.cartao}>
            <p className={styles.titulo}>
              <strong>{identificacao.titulo}</strong> <span>{identificacao.moeda}</span>
            </p>
            <p className={styles.detalhe}>{identificacao.detalhe}</p>
          </div>
        </div>
      }
      campos={
        <JustificativaField
          rows={3}
          value={justificativa.valor}
          onChange={justificativa.digitar}
          error={justificativa.erro}
          testIds={{
            campo: "situacao-cotacao-justificativa",
            contador: "situacao-cotacao-contador",
            erro: "situacao-cotacao-justificativa-erro",
          }}
        />
      }
      onConfirmar={onConfirmar}
      onCancelar={onCancelar}
    />
  );
}
